/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_WholesaleInputs */

const en_price_wholesale = /** @type {(inputs: Price_WholesaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wholesale`)
};

/**
* | output |
* | --- |
* | "Wholesale" |
*
* @param {Price_WholesaleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_wholesale = /** @type {((inputs?: Price_WholesaleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_WholesaleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_wholesale(inputs)
});